import { render, staticRenderFns } from "./ManualDetail.vue?vue&type=template&id=8dde78a4&"
import script from "./ManualDetail.vue?vue&type=script&lang=js&"
export * from "./ManualDetail.vue?vue&type=script&lang=js&"
import style0 from "./ManualDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports